<template>
  <div class="login">
    <div class="tit">
      <h3>登录</h3>
      <!--      <a class="wei">-->
      <!--        <i class="iconfont iconweixin"></i>微信扫码登录-->
      <!--      </a>-->
    </div>
    <el-form class="login-form" ref="loginForm" :model="form" :rules="rules">
      <el-form-item prop="user">
        <p class="label">
          <i class="iconfont iconshouji"></i>
          <label>邮箱或手机号</label>
        </p>
        <el-input
          v-model="form.user"
          auto-complete="off"
          placeholder="请输入邮箱或手机号"
          @keyup.enter.native="setPasswordFocus"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <p class="label">
          <i class="iconfont iconmima1"></i>
          <label>密码</label>
        </p>
        <el-input
          ref="password"
          v-model="form.password"
          auto-complete="off"
          placeholder="请输入密码"
          @keyup.enter.native="submitLogin"
          show-password
        ></el-input>
      </el-form-item>
      <el-form :inline="true">
        <el-form-item class="btn">
          <a class="btn-black" @mousedown="submitLogin">登录</a>
        </el-form-item>
        <!-- <el-form-item class="btn">
          <a class="btn-border" @mousedown="register">
            <i class="iconfont iconxiugai"></i>
            <span>注册帐号</span>
          </a>
        </el-form-item> -->
      </el-form>
      <el-form-item>
        <div class="text-small">
          忘记密码，<a class="link" @mousedown="findPassword">找回密码</a>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { loginUser, loginAuthKey } from "../../../api/auth";
import regexJs from "../../../utils/regex";
import { setTempUser, setToken, setNewUser } from "../../../utils/storage";
import { message } from "@/utils/resetMessage";

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        this.isError = "";
        callback(new Error("请填写密码"));
      } else {
        callback();
      }
    };
    return {
      form: {
        user: "",
        password: "",
        remember: "on",
        type: constants.loginNameType.email,
      },
      rules: {
        user: [
          { required: true, trigger: "blur", message: "请输入邮箱或手机号" },
        ],
        password: [
          { required: true, validator: validatePass, message: "请输入密码" },
        ],
      },
      passwordFocus: false,
      isError: "",
    };
  },
  created() {
    //判断是否登录
  },
  mounted() {
    //判断是否存在authKey--调用接口
    if (this.$route.query != null && this.$route.query.loginAuthKey != null) {
      this.$store.commit("token", this.$route.query.loginAuthKey);
      setToken(this.$route.query.loginAuthKey);
      //调用登录
      let data = {
        type: this.$route.query.type,
      };
      loginAuthKey(data)
        .then((result) => {
          this.$store.commit("loginNameType", this.$route.query.type);
          this.$store.dispatch("setUserInfo", result.account);
          this.$store.commit("updateShowAdvert", false);
          //this.$store.commit("updateShowPost", true);
          //this.$store.commit("updateShowPost", result.firstCharge); //首充活动
          // if (result.account.blance > 0) {
          //   this.$store.commit("updateShowPost", true); //首充活动
          // } else {
          //   this.$store.commit("updateShowPost", result.firstCharge); //首充活动
          // }
          this.$store.commit("updateShowPost", true);
          setToken(this.$route.query.loginAuthKey);
          setNewUser(false);
          setTempUser(""); //用户为null
          //返回到上一个页面
          this.$router.push({ path: "/materialDownload" });
        })
        .catch((error) => {
          message.error({
            message: error,
            duration: 4000,
            offset: 80,
          });
          this.isError = error;
        });
    }
  },
  methods: {
    submitLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.judgeUserType();
          loginUser(this.form)
            .then((result) => {
              this.$store.commit("loginNameType", this.form.type);
              this.$store.dispatch("setUserInfo", result.account);
              this.$store.commit("token", result.token);
              if (result.account.gender == 1) {
                this.$store.commit("updateShowPost", true); //首充活动
                this.$store.commit("updateShowAdvert", true);
                setToken(result.token);
                setTempUser(""); //用户为null
                //返回到上一个页面
                this.$router.push({ path: "/materialDownload" });
              } else {
                if (result.account.blance <= 3) {
                  message.error({
                    message: "该网站已经暂停服务",
                    duration: 4000,
                    offset: 80,
                  });
                } else {
                  this.$store.commit("updateShowPost", false); //首充活动
                  this.$store.commit("updateShowAdvert", false);
                  setToken(result.token);
                  setTempUser(""); //用户为null
                  //返回到上一个页面
                  this.$router.push({ path: "/materialDownload" });
                }
              }
            })
            .catch((error) => {
              console.log(error);
              message.error({
                message: error,
                duration: 4000,
                offset: 80,
              });
              this.isError = error;
            });
        }
      });
    },
    judgeUserType() {
      this.form.type = regexJs.email.test(this.form.user)
        ? constants.loginNameType.email
        : constants.loginNameType.phone;
    },
    findPassword() {
      this.$router.push({ path: "/reset" });
    },
    register() {
      this.$router.push({ path: "/registered" });
    },
    setPasswordFocus() {
      if (this.form.user !== "") this.$refs.password.focus();
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  padding-top: 50px;
  .tit {
    margin-bottom: 50px;
    overflow: hidden;
    h3 {
      float: left;
      font-size: 24px;
      color: #1872f9;
    }
    .wei {
      float: right;
      line-height: 30px;
      color: #7e7e7e;
      font-size: 14px;
      cursor: pointer;
      .iconfont {
        margin-right: 10px;
        color: #5acd54;
        font-size: 16px;
      }
    }
  }
}
.el-form-item__error.error {
  padding: 0;
  position: relative;
  top: 0;
  left: 0;
  line-height: 0;
  margin-top: -20px;
}
</style>
